
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-do",
      function () {
        return require("private-next-pages/what-we-do.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-do"])
      });
    }
  